import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'echarts-liquidfill/src/liquidFill.js'; // 引入提示框

require('echarts/lib/component/tooltip'); // 引入标题组件


require('echarts/lib/component/title');

require('echarts/lib/component/legendScroll');

import { getAction } from '@/api/manage'; // 日期格式化插件

import moment from 'moment';
import Vue from 'vue';
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

Vue.use(VueAMap); // 初始化vue-amap

VueAMap.initAMapApiLoader({
  // 高德的key
  key: '44641f38739649861c9d7d31f69b4ac2',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  v: '1.4.4'
});
var amapManager = new VueAMap.AMapManager();
import { querySiteBySt, queryWarn, queryRealtime, mainRealtime as _mainRealtime, querySiteList as _querySiteList } from '@/api/api'; // 水质标准分布

import waterType from '@comp/bigData/waterType'; // 水质在线
// 水文监测

import servicePopulation from '@comp/bigData/servicePopulationSx'; // 预警统计

import warnStatistics from '@comp/bigData/warnStatisticsSx'; // 水质趋势

import warnStatisticsJinchu from '@comp/bigData/waterStatistics-jinchu';
import screenfull from 'screenfull';
import hydrologyWenJinchu from '@comp/bigData/hydrology-wen-jinchu';
import hydrologyWenJinkou from '@comp/bigData/hydrology-jinkou';
import hydrology from '@comp/bigData/hydrology';
import hydrologyWenDj from '@comp/bigData/hydrology-wen-dj';
import hydrologyWenXj from '@comp/bigData/hydrology-wen-xj';
import hydrologyWenTs from '@comp/bigData/hydrology-wen-ts';
export default {
  data: function data() {
    return {
      siteInfo: {},
      headDate: '',
      headWeek: '',
      headTime: '',
      amapManager: amapManager,
      zoom: 12,
      center: [120.726149, 29.951588],
      mapStyle: 'amap://styles/dark',
      //设置地图样式
      plugin: [{
        pName: 'MapType',
        defaultType: 1,
        showRoad: false,
        showTraffic: false,
        events: {
          init: function init(o) {
            console.log(o);
          }
        }
      }],
      lines: [],
      markers: [],
      windows: [],
      window: null,
      waterWarnList: [],
      siteWarnList: [],
      isFullscreen: false,
      waterTitle: '',
      // 表头
      columns: [],
      dataSource: [],
      inletStatus: '',
      loading: false,
      dataMap: null,
      dataMap2: null,
      dataMap3: null,
      dataMap4: null,
      dataMap5: null,
      dataMap6: null,
      siteName: '进口水净化站',
      siteName2: '进口泵站',
      autoplaySpeed: 3000,
      imgSrc: '',
      imgSrc2: '',
      imgSrc3: '',
      imgSrc4: '',
      imgSrc5: '',
      imgSrc6: '',
      swiperIndex1: 0,
      swiperIndex2: 0
    };
  },
  created: function created() {
    this.getInfo('7');
    this.getInfo('8');
    this.getInfo('12');
    this.getInfo('10');
    this.getInfo('9');
    this.getInfo('11');
    this.querySiteList('7');
    this.querySiteList('8');
    this.querySiteList('12');
    this.querySiteList('10');
    this.querySiteList('9');
    this.querySiteList('11');
  },
  mounted: function mounted() {
    var _this = this;

    moment.locale('zh-cn');
    this.realtime();
    this.getSite();
    this.getWarn('1');
    this.getWarn('4');
    setInterval(this.scroll, 1000);
    setInterval(function () {
      var date = new Date();
      _this.headDate = moment(date).format('YYYY年MM月DD日');
      _this.headWeek = moment(date).format('dddd');
      console.log(_this.headWeek);
    }, 60000);
    this.getDate();
    setInterval(function () {
      _this.swiper();
    }, 60000);
  },
  components: {
    waterType: waterType,
    servicePopulation: servicePopulation,
    warnStatistics: warnStatistics,
    warnStatisticsJinchu: warnStatisticsJinchu,
    hydrologyWenJinchu: hydrologyWenJinchu,
    hydrologyWenJinkou: hydrologyWenJinkou,
    hydrology: hydrology,
    hydrologyWenDj: hydrologyWenDj,
    hydrologyWenXj: hydrologyWenXj,
    hydrologyWenTs: hydrologyWenTs
  },
  methods: {
    swiper: function swiper() {
      if (this.swiperIndex1 < 5) {
        this.$refs.swiper1.goTo(this.swiperIndex1 + 1);
      } else {
        this.$refs.swiper1.goTo(0);
      }

      if (this.swiperIndex2 < 5) {
        this.$refs.swiper2.goTo(this.swiperIndex2 + 1);
      } else {
        this.$refs.swiper2.goTo(0);
      }
    },
    querySiteList: function querySiteList(id) {
      var _this2 = this;

      var that = this; // 污水站点

      _querySiteList({
        id: id
      }).then(function (res) {
        if (res) {
          if (id == '8') {
            _this2.imgSrc = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '12') {
            _this2.imgSrc2 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '7') {
            _this2.imgSrc3 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '10') {
            _this2.imgSrc4 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '9') {
            _this2.imgSrc5 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          } else if (id == '11') {
            _this2.imgSrc6 = location.origin + '/env/sys/common/file/view/' + res.result.records[0].photo;
          }
        }
      });
    },
    afterChange: function afterChange(e) {
      this.swiperIndex1 = e;

      switch (e) {
        case 0:
          this.siteName = '进口水净化站';
          break;

        case 1:
          this.siteName = '进口泵站';
          break;

        case 2:
          this.siteName = '出口水体净化站';
          break;

        case 3:
          this.siteName = '东江';
          break;

        case 4:
          this.siteName = '西江';
          break;

        case 5:
          this.siteName = '涂山桥';
          break;

        default:
          break;
      }
    },
    afterChange2: function afterChange2(e) {
      this.swiperIndex2 = e;

      switch (e) {
        case 0:
          this.siteName2 = '进口泵站';
          break;

        case 1:
          this.siteName2 = '进口水净化站';
          break;

        case 2:
          this.siteName2 = '出口水体净化站';
          break;

        case 3:
          this.siteName2 = '东江';
          break;

        case 4:
          this.siteName2 = '西江';
          break;

        case 5:
          this.siteName2 = '涂山桥';
          break;

        default:
          break;
      }
    },
    getInfo: function getInfo(id) {
      var that = this;
      var params = {
        type: '1',
        id: id
      }; // 污水站点

      queryRealtime(params).then(function (res) {
        if (res) {
          if (res.result.records.length > 0) {
            if (id == '8') {
              that.dataMap = res.result.records[0].dataMap || null;
            } else if (id == '12') {
              that.dataMap2 = res.result.records[0].dataMap || null;
            } else if (id == '7') {
              that.dataMap3 = res.result.records[0].dataMap || null;
            } else if (id == '10') {
              that.dataMap4 = res.result.records[0].dataMap || null;
            } else if (id == '9') {
              that.dataMap5 = res.result.records[0].dataMap || null;
            } else if (id == '11') {
              that.dataMap6 = res.result.records[0].dataMap || null;
            }
          } else {
            if (id == '8') {
              that.dataMap = null;
            } else if (id == '12') {
              that.dataMap2 = null;
            } else if (id == '7') {
              that.dataMap3 = null;
            }
          }
        }
      });
    },
    mainRealtime: function mainRealtime(id) {
      var that = this;
      that.columns = [];
      that.dataSource = [];

      _mainRealtime({
        siteId: id
      }).then(function (res) {
        res.result.factorMap.all.forEach(function (e, i) {
          that.columns.push({
            title: e.title,
            align: 'center',
            width: '100px',
            dataIndex: e.code,
            customRender: function customRender(text, record, index) {
              return that.renderCol(e.code, text, record);
            }
          });
        });
        that.dataSource = res.result.records;
      });
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var h = this.$createElement;
      var data = record.dataMap[code] || {
        value: ''
      };

      if (data.status == '2') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-down"
          },
          "style": "float:right"
        })]);
      } else if (data.status == '3') {
        return h("span", {
          "class": "redText",
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value, h("a-icon", {
          "attrs": {
            "type": "arrow-up"
          },
          "style": "float:right"
        })]);
      } else {
        return h("span", {
          "attrs": {
            "title": '原始数据： ' + data.raw
          }
        }, [data.value]);
      }
    },
    realtime: function realtime() {
      var _this3 = this;

      queryRealtime({
        type: 1,
        id: 8
      }).then(function (res) {
        _this3.waterTitle = res.result.records[0].currentStandard ? res.result.records[0].currentStandard.title : '';

        _this3.$refs.water.queryWaterType();
      });
    },
    fullscreen: function fullscreen() {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },
    getDate: function getDate() {
      var _this4 = this;

      var date = new Date();
      this.headDate = moment(date).format('YYYY年MM月DD日');
      this.headWeek = moment(date).format('dddd');
      this.headTime = moment(date).format('HH:mm:ss');
      setInterval(function () {
        var time = new Date();
        _this4.headTime = moment(time).format('HH:mm:ss');

        _this4.$forceUpdate();
      }, 1000);
    },
    scroll: function scroll() {
      var _this5 = this;

      setTimeout(function () {
        if (_this5.waterWarnList.length > 5) {
          _this5.waterWarnList.push(_this5.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this5.waterWarnList.shift(); //删除数组的第一个元素

        }

        if (_this5.siteWarnList.length > 5) {
          _this5.siteWarnList.push(_this5.siteWarnList[0]);

          _this5.siteWarnList.shift();
        }
      }, 500);
    },
    getWarn: function getWarn(category) {
      var that = this;
      var params = {
        pageNo: 1,
        pageSize: 10,
        category: category,
        st: 53
      }; // 污水站点

      queryWarn(params).then(function (res) {
        if (res) {
          switch (category) {
            case '1':
              that.waterWarnList = res.result.records;
              break;

            case '4':
              that.siteWarnList = res.result.records;
              break;
          }
        }
      });
    },
    goHome: function goHome() {
      this.$router.push('/monitor/map');
    },
    toData: function toData() {
      this.$router.push('/ds/siteindex');
    },
    getSite: function getSite() {
      var params = {};
      var that = this; // 污水站点

      querySiteBySt(params).then(function (res) {
        if (res) {
          var markers = [];
          var windows = [];
          res.result.forEach(function (item, index) {
            var bgColor = '';

            switch (item.st) {
              case '21':
                bgColor = '#5CBB44';
                break;

              case '22':
                bgColor = '#D52B2B';
                break;

              case '52':
                bgColor = '#DD9222';
                break;

              case '53':
                bgColor = '#DD9222';
                break;
            }

            if (item.onlineStatus) {
              bgColor = 'green';
            }

            var mg = 0;

            if (item.id == 9) {
              mg = '-30px';
            }

            var width = '110px';

            if (item.id == 9 || item.id == 10 || item.id == 11) {
              width = '60px';
            }

            markers.push({
              id: item.id,
              position: [item.longitude, item.latitude],
              title: item.name,
              content: // '<hr style="width:40px;border: 1px dashed '+bgColor+';transform-origin: top;transform: rotate(-90deg);"/>'+"<div style='background-color:" +
              // bgColor +
              // ';color:#ffffff;padding:5px;min-width: ' +
              // width +
              // ";font-size:12px;text-align: center;border-radius:5px;margin-top:"+mg+";'>" +
              // item.name +
              // // ":"+item.online+
              // '</div>', //内容
              "<div style='background-color:" + bgColor + ';margin-left:' + mg + ';color:#ffffff;padding:5px;width:' + width + ";font-size:12px;text-align: center;border-radius:5px'>" + item.name + '</div>',
              //内容
              events: {
                click: function click() {
                  that.windows.forEach(function (v) {
                    v.visible = false; //关闭窗体
                  });
                  that.window = that.windows[index];
                  that.$nextTick(function () {
                    that.mainRealtime(item.id);
                    that.window.visible = true; //点击点坐标，出现信息窗体
                  });
                }
              }
            });
            windows.push({
              position: [item.longitude, item.latitude],
              offset: [65, -30],
              //窗体偏移
              visible: false,
              //初始是否显示
              siteName: item.name,
              onlineStatus: item.onlineStatus,
              siteId: item.id
            });
          }); //  加点

          that.markers = markers; //加弹窗

          that.windows = windows;
        }
      });
    }
  }
};